import { RoleMembershipDrawerComponent } from '../../../shared/dialogs/role-membership-drawer/role-membership-drawer.component';
import { IDrawerComponentLiaison } from '../../../shared/interfaces/idrawer-component-liaison';
import { Role } from '../../../shared/models/role.model';

export class RoleMembershipDrawerLiaison implements IDrawerComponentLiaison {
    // Constructor.
    public constructor(private role: Role) {
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-role-membership-drawer';
    }

    public drawerComponentInitialized(drawerComponentParam: any): void {
        let drawerComponent: RoleMembershipDrawerComponent = <RoleMembershipDrawerComponent>drawerComponentParam;

        drawerComponent.role = this.role;
    }
    public drawerComponentDestroyed(drawerComponentParam: any): void {
        // TO DO:  IF THE MANAGE ROLE MEMBERS CHANGED ANY ROLES, UPDATE THE DISPLAY OF THE ROLE'S MEMBER COUNT.
    }

    public get LiaisonHasInitialized(): boolean {
        // TO DO:  IMPLEMENT THIS METHOD.
        return true;
    }

    // Getter method.
    public get Role(): Role {
        return this.role;
    } 
}
